module.exports = __webpack_public_path__ + "dc9c1aab9535c4cfa5da9a171bb7eed0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/dive-tank-s.png
// module id = 2628
// module chunks = 0